import { ClientError } from "graphql-request";
import { useEffect, useState } from "react";

import { useGraphqlClientWithAuth } from "~/lib/client/hooks/useGraphqlClient";

const TARGET_QUEST_IDS: number[] = [716, 1590, 2089, 2380];

function useCurrentUserVerifyCode(questId: number) {
  const client = useGraphqlClientWithAuth();
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    if (!client) return;
    if (!TARGET_QUEST_IDS.includes(questId)) return;

    client
      .fetchCurrentUserVerifyCode({ questId })
      .then((res) => {
        setCode(res.currentUserQuestVerifyCode);
      })
      .catch((err) => {
        if (err instanceof ClientError) {
          console.error(err.response.errors);
        } else {
          console.error(`[unexpected] ${err}`);
        }
      });
  }, [client, questId]);

  return code;
}

export default useCurrentUserVerifyCode;
